import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";
// import LogRocket from 'logrocket';

// // Initialize LogRocket
// LogRocket.init('your-org-id/your-project-name');

// // Initialize Sentry
// Sentry.init({
//   dsn: "https://YOUR_SENTRY_DSN.ingest.sentry.io/YOUR_PROJECT_ID",
//   integrations: [new BrowserTracing()],
//   tracesSampleRate: 1.0,
//   environment: process.env.NODE_ENV,
// });

// // Link LogRocket to Sentry (updated API)
// LogRocket.getSessionURL(sessionURL => {
//   Sentry.setExtra("LogRocketSession", sessionURL);
// });

// // Identify user
// const user = JSON.parse(localStorage.getItem("user")) || null;
// if (user) {
//   LogRocket.identify(user.user_id, {
//     name: `${user.first_name} ${user.last_name}`,
//     email: user.email,
//     accountType: user.username
//   });

//   Sentry.setUser({
//     id: user.user_id,
//     username: `${user.first_name} ${user.last_name}`,
//     email: user.email
//   });
// }

// Service Worker registration
serviceWorkerRegistration.register();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('./serviceWorkerRegistration.js')
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch((error) => {
      console.log('Service Worker registration failed:', error);
    });
}

// Create root and render app
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();